import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isNone as n } from "../../core/maybe.js";
import { getMetersPerVerticalUnitForSR as e } from "../../core/unitUtils.js";
import { equals as t } from "./spatialReferenceUtils.js";

function o(o, f, u) {
  if (n(f) || n(u) || u.vcsWkid || t(f, u)) return null;
  var a = e(f) / e(u);
  if (1 === a) return null;

  switch (o) {
    case "point":
    case "esriGeometryPoint":
      return function (n) {
        return r(n, a);
      };

    case "polyline":
    case "esriGeometryPolyline":
      return function (n) {
        return s(n, a);
      };

    case "polygon":
    case "esriGeometryPolygon":
      return function (n) {
        return i(n, a);
      };

    case "multipoint":
    case "esriGeometryMultipoint":
      return function (n) {
        return c(n, a);
      };

    case "extent":
    case "esriGeometryExtent":
      return function (n) {
        return l(n, a);
      };

    default:
      return null;
  }
}

function r(n, e) {
  n && null != n.z && (n.z *= e);
}

function i(n, e) {
  if (n) {
    var _iterator = _createForOfIteratorHelper(n.rings),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;

        var _iterator2 = _createForOfIteratorHelper(_t),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _n = _step2.value;
            _n.length > 2 && (_n[2] *= e);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}

function s(n, e) {
  if (n) {
    var _iterator3 = _createForOfIteratorHelper(n.paths),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _t2 = _step3.value;

        var _iterator4 = _createForOfIteratorHelper(_t2),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var _n2 = _step4.value;
            _n2.length > 2 && (_n2[2] *= e);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
}

function c(n, e) {
  if (n) {
    var _iterator5 = _createForOfIteratorHelper(n.points),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _t3 = _step5.value;
        _t3.length > 2 && (_t3[2] *= e);
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }
}

function l(n, e) {
  n && null != n.zmin && null != n.zmax && (n.zmin *= e, n.zmax *= e);
}

export { o as getGeometryZScaler };